<mat-accordion class="example-headers-align card shadow-lg p-3">
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-end pt-4">
                            <h3 style="opacity: 0.7;">Bitácora</h3>
                        </div>
                    </div>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <p><strong>Es necesario poner una fecha anterior a la del día de hoy para obtener resultados.</strong></p>

        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-md-4 col-lg-3">
                    <mat-form-field class="w-100">
                        <mat-label>Fecha Inicio</mat-label>
                        <input matInput [(ngModel)]="fechaInicio" [matDatepicker]="picker" (focus)="picker.open()"
                            readonly required>
                    </mat-form-field>
                    <mat-datepicker #picker></mat-datepicker>
                </div>
                <div class="col-12 col-md-4 col-lg-3">
                    <mat-form-field class="w-100">
                        <mat-label>Fecha Fin</mat-label>
                        <input matInput [(ngModel)]="fechaFin" [matDatepicker]="picker2" (focus)="picker2.open()"
                            readonly required>
                    </mat-form-field>
                    <mat-datepicker #picker2></mat-datepicker>
                </div>
                <div class="col-12 col-lg-4">
                    <button [disabled]="!fechaInicio || !fechaFin" mat-flat-button color="primary"
                        (click)="page=0;getBitacora()">
                        Buscar
                    </button>
                    <button  mat-mini-fab (click)="fechaFin=null;fechaInicio=null;" class="ml-2">
                        <mat-icon>deleter</mat-icon>
                    </button>
                </div>
            </div>

            <div *ngIf="dataSourceBitacora.data.length > 0" class="row">
                <div class="col-12">
                    <table class="mt-3 tabla-responsiva" mat-table [dataSource]="dataSourceBitacora">

                        <ng-container matColumnDef="nombreCompleto">
                            <th mat-header-cell *matHeaderCellDef>Usuario</th>
                            <td mat-cell *matCellDef="let element"> {{ element.nombreCompleto }} - ({{element.usuario}})
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="accion">
                            <th mat-header-cell *matHeaderCellDef>Acción</th>
                            <td mat-cell *matCellDef="let element"> {{ element.accion }} </td>
                        </ng-container>

                        <ng-container matColumnDef="fechaRegistro">
                            <th mat-header-cell *matHeaderCellDef>Fecha Registro</th>
                            <td mat-cell *matCellDef="let element"> {{ element.fechaRegistro }} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsBitacora"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsBitacora;"></tr>
                    </table>
                </div>
                <div class="col-12 col-lg-8 d-flex justify-content-start align-items-center">
                    <!-- Paginador -->
                    <div class="pr-2">
                        <button  mat-mini-fab (click)="cambiarPagina(0)" [disabled]="page === 0" class="">
                            <mat-icon>skip_previous</mat-icon>
                        </button>
                      
                        <button  mat-mini-fab (click)="cambiarPagina(page - 1)" [disabled]="page === 0" class="">                            
                            <mat-icon>navigate_before</mat-icon>
                        </button>
                      
                        <span class="">
                          Página <strong>{{ page + 1 }}</strong> de {{ totalPages }}
                        </span>
                      
                        <button  mat-mini-fab (click)="cambiarPagina(page + 1)" [disabled]="page >= totalPages - 1" class="">
                          <mat-icon>navigate_next</mat-icon>
                        </button>
                      
                        <button  mat-mini-fab (click)="cambiarPagina(totalPages - 1)" [disabled]="page >= totalPages - 1" class="">
                            <mat-icon>skip_next</mat-icon>
                        </button>
                      </div>
                      

                    <!-- Selector de tamaño de página -->
                    <div>

                        <mat-form-field>
                            <mat-label>Registros por página:</mat-label>
                            <mat-select (selectionChange)="cambiarTamano($event.value)">
                                <mat-option value="5">5</mat-option>
                                <mat-option value="10">10</mat-option>
                                <mat-option value="20">20</mat-option>
                                <mat-option value="50">50</mat-option>                                
                            </mat-select>
                        </mat-form-field>

                    </div>
                </div>
            </div>


            <div *ngIf="dataSourceBitacora.data.length === 0" class="text-center p-3 row">
                <p>No hay registros en la bitácora.</p>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>